import { render, staticRenderFns } from "./JsonInput.vue?vue&type=template&id=7fac9495&scoped=true&"
import script from "./JsonInput.vue?vue&type=script&lang=ts&"
export * from "./JsonInput.vue?vue&type=script&lang=ts&"
import style0 from "./JsonInput.vue?vue&type=style&index=0&id=7fac9495&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fac9495",
  null
  
)

export default component.exports